import React from 'react'
import {useSelector} from 'react-redux'
import {useMediaQuery} from '@mui/material'
import CardActionArea from '@mui/material/CardActionArea'
import CardHeader from '@mui/material/CardHeader'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowDown'
import CardVisitActionsComponent from './card_visit_actions.component'
import BoxAtom from '../../../@atoms/to_layout/box/box.atom'
import StackAtom from '../../../@atoms/to_layout/stack/stack.atom'
import TypographyAtom from '../../../@atoms/to_content/typography/typography.atom'
import VisitSubHeaderWrapperAtom from '../../../@atoms/to_content/visit_subheader_wrapper/visit_subheader_wrapper.atom'
import ItemDetailsSummaryAtom from '../../../@atoms/to_content/item_details_summary/item_details_summary.atom'
import {VisitActionProps, VisitProps} from '../card_visit_details.component'
import {RootState} from '../../../store_redux'
import {Visit} from '../../../props_reusable/visit'
import utils from '../../../utils'

const VisitStatus: React.FC<
  Pick<
    Visit,
    'visitStatus' | 'bookedSlotDetail' | 'visitType' | 'itemDetailsSummary'
  >
> = function ({visitStatus, bookedSlotDetail, visitType, itemDetailsSummary}) {
  const labels = useSelector((state: RootState) => state.labels)

  const formatDate = () => {
    const formattedDateString = bookedSlotDetail?.visitDate
      ? utils
          .formatDate(bookedSlotDetail?.visitDate, {
            weekday: 'long',
            month: 'long',
            day: 'numeric',
          })
          .replace(',', '')
      : ''
    // eslint-disable-next-line

    const formatedDtStr = visitStatus
      ? `: ${formattedDateString}`
      : formattedDateString

    return bookedSlotDetail ? formatedDtStr : ''
  }
  const isUndatedOrder = utils.isVisitUndated(bookedSlotDetail?.visitDate)

  const getDeliveryTime = ({...src}) => {
    if (src.deliveryWindow) {
      return src?.deliveryWindow
    }
    return `${utils.formatTime(src?.startTime)} - ${utils.formatTime(
      src?.endTime,
    )}`
  }

  return (
    <BoxAtom className="status-wrapper">
      {!isUndatedOrder ? (
        <TypographyAtom ahd_type="status">
          {visitStatus}
          {formatDate()} &nbsp;
          {bookedSlotDetail && (
            <TypographyAtom ahd_type="sData inline">
              {getDeliveryTime(bookedSlotDetail)}
            </TypographyAtom>
          )}
        </TypographyAtom>
      ) : (
        <TypographyAtom ahd_type="status" className="case-inherit">
          {labels.myOrders.visitCardHeader?.undatedVisitLabel}
        </TypographyAtom>
      )}
      <ItemDetailsSummaryAtom
        visitType={visitType}
        itemDetailsSummary={itemDetailsSummary}
        itemsSummaryLabels={labels.myOrders.visitCardHeader.itemsSummary}
      />
    </BoxAtom>
  )
}

const CardVisitTitle: React.FC<Pick<Visit, 'visitNumber'>> = function ({
  visitNumber,
}) {
  const labels = useSelector((state: RootState) => state.labels)

  const {title} = labels.myOrders.visitCardHeader
  return (
    <BoxAtom className="visit-title-wrapper">
      <TypographyAtom ahd_type="subheading">{title}:</TypographyAtom>
      <TypographyAtom ahd_type="uid">{visitNumber}</TypographyAtom>
    </BoxAtom>
  )
}

const CardVisitHeaderAction: React.FC<VisitActionProps> = function ({
  expanded,
  setExpanded,
}) {
  const labels = useSelector((state: RootState) => state.labels)
  const handleExpandClick = () => {
    setExpanded(!expanded)
  }

  const {accordianLabel} = labels.myOrders.visitCardHeader

  return (
    <StackAtom ap_type="column" className="visit-action-wrapper">
      <CardActionArea disableRipple onClick={handleExpandClick}>
        <TypographyAtom ahd_type="navLink" justifyContent="flex-end">
          {accordianLabel}
          <KeyboardArrowUpIcon aria-expanded={expanded} />
        </TypographyAtom>
      </CardActionArea>
    </StackAtom>
  )
}

export const VisitActionWithInstructions: React.FC<
  Pick<VisitActionProps, 'expanded'> & VisitProps
> = function ({expanded, visit}) {
  return (
    <BoxAtom className="instruction-wrapper">
      {expanded && !!visit.specialInstructions && (
        <TypographyAtom ahd_type="sData">
          {visit.specialInstructions}
        </TypographyAtom>
      )}
      <CardVisitActionsComponent {...visit} />
    </BoxAtom>
  )
}

const CardVisitHeaderComponent: React.FC<VisitActionProps & VisitProps> =
  function ({expanded, setExpanded, visit}) {
    const matches = useMediaQuery('(min-width:481px)')
    const {visitNumber} = visit
    return (
      <>
        <CardHeader
          action={
            <CardVisitHeaderAction
              expanded={expanded}
              setExpanded={setExpanded}
            />
          }
          title={<CardVisitTitle visitNumber={visitNumber} />}
        />
        <VisitSubHeaderWrapperAtom>
          <VisitStatus {...visit} />
          {matches && (
            <VisitActionWithInstructions expanded={expanded} visit={visit} />
          )}
        </VisitSubHeaderWrapperAtom>
      </>
    )
  }

export default CardVisitHeaderComponent
